<template>
  <Layout>
    <LayoutBody mode="horizontal" class="page-body--row">
      <LayoutContent class="content-body">
        <Panel class="tools">
          <div class="part-code-tips" v-show="ansProgressStatus > 0">{{ computedPartCode }}</div>
          <div v-show="isShowCountDown && time > -1">
            <!-- <div class="count_down_null" v-if="time < 0">- : - : -</div> -->
            <Count-Down
              :time="time"
              @finish="finish"
              ref="countDown"
              class="count_down"
              :autoStart="false"
            >
            </Count-Down>
            <div class="time-remaining">{{ $t('hsk_left_time') }}</div>
          </div>

          <div class="subject_list">
            <el-collapse accordion class="collapse-list" v-model="activeName">
              <el-collapse-item
                v-for="(item, index) in answerSheetList"
                :key="index"
                :name="(index + 1).toString()"
                :disabled="computedCollapseIsDisable(item)"
              >
                <template slot="title">
                  <img :src="partIcon[item.name]" alt="" />
                  <span class="type">{{ item.nameStr }}</span>
                </template>
                <div class="subject_list-item">
                  <div v-for="(data, num) in item.dataInfo" :key="num">
                    <div class="subject_list-flex">
                      <div class="subject_list-line"></div>
                      <div class="title">
                        {{
                          $t(`hsk_${data.segment_code}_part_title`, {
                            count: data.part_code,
                          })
                        }}
                      </div>
                    </div>

                    <div>
                      <span
                        v-for="(ques, no) in data.questionList"
                        :key="no"
                        @click="selectQues(ques, data, false)"
                        v-show="ques.index"
                        :class="[
                          currentQuesIndex && currentQuesIndex <= questionAllList.length
                            ? questionAllList[currentQuesIndex - 1].index === ques.index
                              ? 'active'
                              : ''
                            : '',
                          questionAnswerList[ques.index - 1] &&
                          questionAnswerList[ques.index - 1].answer
                            ? 'finished'
                            : '',
                          $route.query.paperStatus == 1 ? (ques.judge ? 'right' : 'error') : '',
                          $route.query.paperStatus == 1 &&
                          isMarked != 2 &&
                          markIdList.includes(ques.index)
                            ? 'unmarked'
                            : '',
                          isRecording ? 'notAllowed' : '',
                        ]"
                        >{{ ques.index }}</span
                      >
                    </div>
                  </div>
                  <Toolbar justifyContent="center" v-show="isShowCountDown">
                    <button class="btn-yellow btn-submit" @click="submit">
                      {{ computedSubmitDesc }}
                    </button>
                  </Toolbar>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </Panel>
        <div class="content">
          <Panel class="stem">
            <div class="stem--title">
              <div class="stem--title_text">
                <strong>{{ title }}</strong>
                <div class="proportion">
                  <div class="left">
                    <span>{{ currentModule }}</span>
                    <img
                      v-show="isShowPlayIng && isPlaying"
                      src="@/assets/images/playing.gif"
                      alt=""
                      class="playing"
                    />
                  </div>
                  <span v-show="getEffectiveIndex">{{
                    `${getEffectiveIndex} / ${questionNum}`
                  }}</span>
                </div>
              </div>
              <div v-show="isShowCountDown && partTime > -1" class="part-count-down-con">
                <span class="part-count-down-text">{{ computedPartCountDownTitle }}</span>
                <PartCountDown
                  :time="partTime"
                  @finish="partStartOrEnd('countDownFinish')"
                  ref="partCountDown"
                  class="part_count_down"
                  :autoStart="false"
                >
                  <!-- <template #minutes="minutes">
                <div>{{ minutes }}</div>
              </template> -->
                  <template #seconds="seconds">
                    <div>{{ seconds }}</div></template
                  >
                </PartCountDown>
              </div>
            </div>

            <div class="stem--content">
              <slot name="content"></slot>
            </div>
          </Panel>
          <div
            class="page-tools"
            :class="[
              { 'page-tools-disable-prev': disabledPrevButton },
              { 'page-tools-disable-next': disabledNextButton },
            ]"
          >
            <!-- <ButtonTool class="control" type="prev" :disabled="disabledPrevButton" @click.native="onPrev"></ButtonTool> -->
            <div
              :class="['prev', disabledPrevButton || isRecording ? 'prev-disable' : '']"
              @click="onPrev(getPrevNumber)"
              v-show="!disabledPrevButton"
            >
              <div class="number" style="padding-right: 50px">
                {{ getPrevNumber }}
              </div>
              <div class="arrow-left">
                <i class="el-icon-back"></i>
              </div>
            </div>
            <ButtonTool
              :type="isExamMode ? 'none' : 'play'"
              @click.native="playClickHandler"
              v-show="showButtonPlay"
            ></ButtonTool>
            <ButtonTool
              v-show="showButtonPause"
              :type="isExamMode ? 'none' : 'pause'"
              @click.native="stopClickHandler"
              slot="content"
            ></ButtonTool>
            <!-- <ButtonTool class="control" type="next" :disabled="disabledNextButton" @click.native="onNext"></ButtonTool> -->
            <div
              :class="['next', disabledNextButton || isRecording ? 'next-disable' : '']"
              @click="onNext(getNextNumber)"
              v-show="!disabledNextButton"
            >
              <div class="number" style="padding-left: 50px">
                {{ getNextNumber }}
              </div>
              <div class="arrow-right">
                <i class="el-icon-right"></i>
              </div>
            </div>
          </div>
        </div>
      </LayoutContent>
    </LayoutBody>
    <!-- 弹框确认是否提交试卷 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="300px"
      :show-close="false"
      class="submit-dialog"
      top="30vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>{{ computedTips }}</span>
      <div slot="footer" class="submit-dialog-footer">
        <mui-button @click="cancel" class="button-cancel">{{
          $t('button_common_cancel')
        }}</mui-button>
        <mui-button @click="confirm" class="button-ok" type="yellow">{{
          $t('button_common_ok')
        }}</mui-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="previewVisible"
      width="300px"
      :show-close="false"
      top="30vh"
      class="angle-rounded"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span style="word-break: break-word">{{ previewOrReviewTips }}</span>
      <div slot="footer" class="dialog-footer-preview">
        <button class="btn-yellow btn-submit" @click="cancelPreview">
          {{ $t('cancel_delete_ok') }}
        </button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showTranslateLanguageDialog"
      width="460px"
      top="30vh"
      class="language-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="translate-language-dialog">
        <p class="translate-language-dialog-title">{{ $t('hsk_trasnlation_choose_language') }}</p>
        <div class="language-select-con">
          <p class="title">{{ $t('edit_message_language') }}</p>
          <el-select
            v-model="translationLanguage"
            size="small"
            @change="changeLanguage"
            class="language-select"
          >
            <el-option
              v-for="item in languageList"
              :key="item.value"
              :label="item.title"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="submit-dialog-footer">
        <mui-button @click="closeTranslationLanguageDialog" class="button-ok" type="yellow">{{
          $t('button_common_ok')
        }}</mui-button>
      </div>
    </el-dialog>
    <!-- 弹框进行试音 -->
    <el-dialog
      :title="this.$t('speaking')"
      :visible.sync="testRadioDialogShow"
      top="5vh"
      width="940px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="test-radio"
    >
      <TestRadio
        :showConcatUs="false"
        :testmp3="speakingTestAudio"
        :isDisabled="false"
        :functionType="'microphone'"
        :fromPage="'examination'"
        :listenReviewDuration="0"
        @skip="closeTestAudio"
      >
      </TestRadio>
    </el-dialog>
  </Layout>
</template>

<script>
import CountDown from '@/components/ui/count-down'
import PartCountDown from '@/components/ui/count-down/partCountDown'
// import { apiRequest } from "@/serves/http";
// import CricleTimer from "@/components/ui/CricleTimer/index.vue";
import bus from '@/utils/eventBus'
import { Dialog, Collapse, CollapseItem } from 'element-ui'
import { VOICE_EXTEND_TIME, MARK_RESULT_TYPE } from '@/config'
import { getQueryString } from '@/utils/utils'
import analytics from '@/utils/AnalyticsCenter'
import { mixinMixpanel } from '@/mixins'
import { debounce } from '@/utils/utils'
import { isIpad } from '@/utils/browser'
import { getLanguageSelectList } from '@/utils/hskTool'
import TestRadio from './common/testRadio'
export default {
  mixins: [mixinMixpanel],
  data() {
    return {
      currentQuesIndex: 1, // 题目序号
      currentVoiceIndex: 1, //继续当前音频播放到哪里
      currentModule: '',
      questionNum: 0,
      // 保存题目的数组
      questionAnswerList: [],
      questionIfSave: false, // 是否预保存题目列表
      activeName: '1', // 答题卡默认打开第一个
      deepActiveName: '1', // 参与计算上一题下一题按钮计算使用不能直接使用activeName
      status: true, // true 为点击下一题进入 ,false为选择题号进入
      groupAnsList: [], // 套题存作答记录数组
      partIcon: {
        listen: require('@/assets/images/listen-part.png'),
        read: require('@/assets/images/read-part.png'),
        write: require('@/assets/images/write-part.png'),
        translation: require('@/assets/images/translation-part.png'),
        speaking: require('@/assets/images/speaking-part.png'),
      },
      dialogVisible: false,
      answerSheetList: [],
      // canSubmit: true,
      questionAllList: [], // 所有题目的汇总数组数据(包含列题)
      submitAnsDesc: [],
      // 0 预览 1 作答 2 回顾
      ansProgressStatus: 0,
      // 例题数
      globalExampleNum: 0,
      // 预览dialog
      previewVisible: false,
      // 听力每题音频携带音频音频数量数组
      // listenNumList: [],
      languageDesc: {
        read: this.$t('hsk_submit_reading'),
        listen: this.$t('hsk_listen_name'),
        write: this.$t('hsk_write_name'),
        translation: this.$t('Traduction'),
        speaking: this.$t('speaking'),
      },
      abbreviationState: 0,
      isFinished: false, // 是否已经完成，完成则不继续监听questionIndex 变化
      accumulationNum: 0, // 到哪个环节累加的数量
      bingIndexNo: 1,
      VOICE_EXTEND_TIME: VOICE_EXTEND_TIME,
      isIpad: isIpad(), // 是否是触屏设备
      paperId: this.$route.query.paperId, // 试卷id
      isShowReviewTip: false, // 显示听力回顾说明弹框提示
      showTranslateLanguageDialog: false, // 翻译环节的语言选择弹窗
      translationLanguage: '',
      languageList: [],
      testRadioDialogShow: false,
    }
  },
  components: {
    CountDown,
    PartCountDown,
    // CricleTimer,
    [Dialog.name]: Dialog,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    TestRadio,
  },
  props: {
    // 倒计时的总时间
    time: {
      type: Number,
      default: 30 * 60 * 60 * 1000,
    },
    partTime: {
      type: Number,
      default: -1,
    },
    partCode: {
      type: Number || null,
      default: null,
    },
    // 整套试卷数据
    selectList: {
      type: Array,
      default: () => [],
    },
    // 是否显示播放按钮
    showButtonPlay: {
      type: Boolean,
      default: true,
    },
    showButtonPause: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    // 答案
    answerObject: {
      type: Object,
      default: () => {},
    },
    // 作答记录对象
    answerNotesArray: {
      type: Array,
      default: () => [],
    },
    //是否显示倒计时
    isShowCountDown: {
      type: Boolean,
      default: true,
    },
    playVoiceTime: {
      type: [Number, String],
      default: '',
    },
    // 是否答题模式
    isExamMode: {
      type: Boolean,
      default: true,
    },
    listenNumList: {
      type: Array,
      default: () => [],
    },
    partProgressList: {
      type: Array,
      default: () => [],
    },
    examinationId: {
      type: [String, Number],
      default: '',
    },
    isMarked: {
      type: Number,
    },
    markIdList: {
      type: Array,
      default: () => [],
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
    speakingTestAudio: {
      type: String,
      default: '',
    },
  },
  computed: {
    isShowPlayIng() {
      let segment_code =
        this.questionAllList[
          this.currentQuesIndex - 1 || this.getQuesListIndexForVoice(this.currentVoiceIndex) - 1
        ]?.segment_code
      console.log('segment_code', segment_code, 'ansProgressStatus', this.ansProgressStatus)
      return (
        ([0, 1].includes(this.ansProgressStatus) && segment_code == 'listen' && this.isExamMode) ||
        ((segment_code == 'translation' || segment_code == 'speaking') && this.isExamMode)
      )
    },
    // 翻译|口语正在录音（拿来禁用题号的点击/前后题的切换）
    isRecording() {
      return this.$store.state.simulation.examnationRecording
    },
    disabledPrevButton() {
      let total = 1
      // // 如果第一道题就是组题的情况
      if (this.selectList[0].dataInfo[0].questionList[0].questions) {
        total = this.selectList[0].dataInfo[0].questionList[0].questions.length
      }
      if (this.isExamMode) {
        console.log('答题模式')
        this.selectList.forEach((item, index) => {
          item.dataInfo.forEach((data) => {
            data.questionList.forEach(() => {
              if (index + 1 < Number(this.deepActiveName)) {
                let firstQuestion = this.selectList[index + 1].dataInfo[0].questionList[0]
                if (firstQuestion.questions) {
                  total = firstQuestion.bigIndex + firstQuestion.questions.length - 1
                } else {
                  total = firstQuestion.count + 1
                }
              }
            })
          })
        })
      }
      return this.currentQuesIndex <= total
    },
    disabledNextButton() {
      let total
      this.selectList.forEach((item, index) => {
        item.dataInfo.forEach((data) => {
          data.questionList.forEach((eg) => {
            if (this.isExamMode) {
              if (index + 1 <= Number(this.deepActiveName)) {
                if (eg.questions) {
                  total = eg.bigIndex
                } else {
                  total = eg.count + 1
                }
              }
            } else {
              total = eg.bigIndex
            }
          })
        })
      })
      return this.currentQuesIndex >= total
    },

    // 根据当前索引值获取当前题的对象
    getAuesObj() {
      let that = this
      let currentObj = {}
      that.questionNum = 0
      let i = 1

      that.selectList.forEach((item) => {
        item.dataInfo.forEach((data) => {
          console.log(data.questionList,'data.questionListdata.questionList')
          data.questionList.forEach((eg) => {
            let manualMark = this.ifquestionManuaMark(eg)
            let ansObj = {
              questionId: eg.index,
              answer: '',
              judge: 0,
              scores: manualMark ? null : 0,
              segmentCode: eg.segment_code,
              partCode: eg.part_code,
              ifGroup: eg.ifGroup,
              num: eg.num,
              nnum: eg.nnum,
            }
            // 预存所有题目,有值则不存
            // 例题的答案不存
            if (!that.questionIfSave && !eg.is_example) {
              that.questionAnswerList.push(ansObj)
            }
            !eg.is_example && that.questionNum++
            if (
              i === (that.currentQuesIndex || that.getQuesListIndexForVoice(that.currentVoiceIndex))
            ) {
              currentObj = eg
              that.currentModule = this.$t(`hsk_${data.segment_code}_part_title`, {
                count: data.part_code,
              }) // 赋值title
            }
            i++ // 总题数
          })
        })
      })
      that.questionIfSave = true
      return currentObj
    },
    // 根据当前index 获取有效的索引题
    getEffectiveIndex() {
      let finalIndex =
        this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)
      if (finalIndex <= this.questionAllList.length) {
        return this.questionAllList?.[finalIndex - 1]?.index || ''
      } else {
        return ''
      }
    },
    // 根据当前index 获取上一题序号
    getPrevNumber() {
      let lastIndex
      //当前是套题，lastIndex为本套题的前一题
      console.log(this.currentQuesIndex, 'this.currentQuesIndex!!!!!!!!!')
      if (!this.currentQuesIndex) {
        return ''
      }
      if (this.questionAllList[this.currentQuesIndex - 1]?.ifGroup) {
        lastIndex = this.currentQuesIndex - this.questionAllList[this.currentQuesIndex - 1].nnum
      } else {
        lastIndex = this.currentQuesIndex - 1
      }
      // 原有逻辑，暂时不知道什么情况下会大于题目长度
      if (lastIndex > this.questionAllList.length) {
        return this.$t('hsk_example_eg')
      }
      // 上一题的对象
      let lastObj = this.questionAllList[lastIndex - 1] || null
      // 如果对象没有index，说明是例题；
      if (!lastObj?.index) {
        return this.$t('hsk_example_eg')
      }
      // 是套题，需要展示区间
      // 有部分套题题型中，第一个为例题，后面为具体的小题，只显示题号区间，隐去例题；
      if (lastObj.ifGroup) {
        let lastStart = lastIndex - lastObj.nnum + 1
        for (let i = 0; i < lastObj.num; i++) {
          if (this.questionAllList[lastStart - 1].index) {
            break
          } else {
            lastStart++
          }
        }
        if (this.questionAllList[lastStart - 1].index == lastObj.index) {
          // 套题但是只有一道题的情况
          return this.questionAllList[lastStart - 1].index
        }
        return this.questionAllList[lastStart - 1].index + '-' + lastObj.index
      }
      // 非套题，返回index
      return this.questionAllList[lastIndex - 1].index
    },
    // 根据当前index 获取下一题/下一套题序号
    getNextNumber() {
      let nextIndex
      if (!this.currentQuesIndex) {
        return ''
      }
      if (this.questionAllList[this.currentQuesIndex - 1]?.ifGroup) {
        nextIndex = this.currentQuesIndex + this.questionAllList[this.currentQuesIndex - 1].num
      } else {
        nextIndex = this.currentQuesIndex + 1
      }
      if (nextIndex > this.questionAllList.length) {
        return this.$t('hsk_example_eg')
      }
      let nextObj = this.questionAllList[nextIndex - 1]
      // 如果是套题
      if (nextObj?.ifGroup) {
        console.log('是套题')
        let nextEnd = nextIndex + nextObj.num - 1
        let nextStart = nextIndex
        // 无例题
        for (let i = 0; i < nextObj.num; i++) {
          if (this.questionAllList[nextStart - 1].index) {
            break
          } else {
            nextStart++
          }
        }
        if (this.questionAllList[nextStart - 1].index == this.questionAllList[nextEnd - 1].index) {
          // 套题只有一题的情况下
          return this.questionAllList[nextEnd - 1].index
        }
        return (
          this.questionAllList[nextStart - 1].index + '-' + this.questionAllList[nextEnd - 1].index
        )
      }
      return nextObj?.index || this.$t('hsk_example_eg')
    },
    // 计算当前 提交按钮应该显示什么描述
    computedSubmitDesc() {

      let finalIndex =
        this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)
      if (finalIndex <= this.questionAllList.length) {
        return this.submitAnsDesc.find(
          (item) => item.name == this.questionAllList[finalIndex - 1].segment_code
        ).status[this.ansProgressStatus]
      } else {
        return this.$t('hsk_submit_paper')
      }
    },
    // 计算当前提交的提示语
    computedTips() {

      let finalIndex =
        this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)
      if (finalIndex <= this.questionAllList.length) {
        return this.getNoAnswerCount(this.questionAllList[finalIndex - 1].segment_code)
      } else {
        return this.getNoAnswerCount()
      }
      // let finalIndex =
      //   this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)
      // if (finalIndex <= this.questionAllList.length) {
      //   return this.submitAnsDesc.find((item) => {
      //     return item.name == this.questionAllList[finalIndex - 1].segment_code
      //   }).tips
      // } else {
      //   return this.$t('hsk_submit_msg')
      // }
    },
    previewOrReviewTips() {
      let min = Math.round(this.time / 60000)
      return this.isShowReviewTip
        ? this.$t('hsk_enter_next_segment_listen_review_start', { count: min })
        : this.isIpad
        ? this.$t('hsk_preview_listen_prompt')
        : this.$t('hsk_preview_listen_msg')
    },
    // 计算当前答题卡是否禁用
    computedCollapseIsDisable() {
      return function (item) {
        let finalIndex =
          this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)
        if (finalIndex <= this.questionAllList.length) {
          return this.questionAllList[finalIndex - 1].segment_code !== item.name && this.isExamMode
        } else {
          return false
        }
      }
    },
    computedPartCountDownTitle() {
      console.log(this.partCode, 'this.partCode')
      if (this.partCode) {
        let finalIndex =
          this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)
        if (finalIndex <= this.questionAllList.length) {
          let segmentCode = this.questionAllList[finalIndex - 1].segment_code
          console.log(segmentCode, 'segmentCode')
          console.log(this.answerSheetList, 'this.answerSheetList')
          let segment = this.answerSheetList?.find((item) => item.name == segmentCode)
          console.log(segment,'segmentsegment')
          let part = segment?.dataInfo?.find((part) => part.part_code == this.partCode)
          return part ? part.topic_title : ''
        }
      }
      return ''
    },
    //计算当前处于什么部分
    computedPartCode() {
      let finalIndex =
        this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)
      if (finalIndex <= this.questionAllList.length) {
        let partCode = this.questionAllList[finalIndex - 1].segment_code
        console.log(partCode, 'partCODEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE')
        if (partCode == 'listen') {
          if (this.ansProgressStatus == 2) {
            return this.$t('review_answers')
          } else {
            return this.$t('listening_section')
          }
        } else if (partCode == 'read') {
          if (this.ansProgressStatus == 2) {
            return this.$t('review_answers')
          } else {
            return this.$t('reading_section')
          }
        } else if (partCode == 'write') {
          if (this.ansProgressStatus == 2) {
            return this.$t('review_answers')
          } else {
            return this.$t('writing_section')
          }
        } else if (partCode == 'translation') {
          if (this.ansProgressStatus == 2) {
            return this.$t('review_answers')
          } else {
            return this.$t('translation_section')
          }
        } else if (partCode == 'speaking') {
          if (this.ansProgressStatus == 2) {
            return this.$t('review_answers')
          } else {
            return this.$t('speaking_section')
          }
        }
        return
      } else {
        return ''
      }
    },
  },
  watch: {
    // 监听选择答案
    answerObject: {
      handler(newVal) {
        console.log('监听选择答案：', newVal)
        // 答题的埋点
        analytics.logEvent('hskweb_mockClick_answer', {
          part: newVal.segmentCode,
          number: newVal.questionId,
          answer: newVal.answer,
        })
        //questionAnswerList不能为空,如果为空需要重新赋值
        if (!this.questionAnswerList.length) {
          this.questionIfSave = false
          this.getAuesObj()
        }
        // 如果作答过 不自动下一题
        // 如果未作答且套题最后一个也不自动下一题
        // 听力除外
        let quesIndex = this.questionAllList
          .filter((item) => {
            return !item.is_example
          })
          .findIndex((item) => {
            return item.index == newVal.questionId
          })
        let curIndex =
          this.questionAllList.findIndex((item) => {
            return item.index == newVal.questionId
          }) + 1
        if (
          !this.questionAnswerList[quesIndex].answer &&
          !(
            this.questionAnswerList[quesIndex].ifGroup &&
            this.questionAnswerList[quesIndex].num === 1
          )
        ) {
          console.log('inner1')
          // 答完当题继续下一题
          let segment_code =
            this.questionAllList[
              this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex) - 1
            ]?.segment_code
          console.log(newVal.segmentCode, segment_code, this.getAuesObj.topic_type)
          // 如果是阅读的主观套题rr,阅读句子排序so ,写作,保存答案,不跳转题目
          if (
            newVal.segmentCode == segment_code &&
            newVal.segmentCode != 'write' &&
            newVal.segmentCode != 'translation' &&
            newVal.segmentCode != 'speaking' &&
            this.getAuesObj.topic_type != 'rr' &&
            this.getAuesObj.topic_type != 'so'
          ) {
            console.log('inner2')
            // 不是听力并且不是当前模块的最后一题自动跳转，否则不跳
            this.currentQuesIndex =
              newVal.segmentCode != 'listen' &&
              curIndex != this.accumulationNum + this.getPartQuesNum(segment_code) - 1
                ? curIndex + 1
                : curIndex
          }
        } else {
          console.log('inner2')
          this.currentQuesIndex = curIndex
        }
        // 如果是例题没有分数则手动拼例题下一个的分数
        if (newVal.scores === undefined) {
          newVal.scores = this.getAuesObj.questions.find((item) => {
            return item.score
          }).score
        }
        // 存题(未作答的也提交)
        let playIndex = this.getQuesListIndexForVoice(this.currentVoiceIndex)
        Object.assign(this.questionAnswerList[quesIndex], newVal, {
          answer: newVal.answer.toString(),
          currentPlayIndex: this.questionAllList[playIndex ? playIndex - 1 : 0].index,
          currentPlayBigIndex: this.questionAllList[playIndex ? playIndex - 1 : 0].bigIndex,
        })
        console.log('存进去的值', this.questionAnswerList)
      },
      deep: true,
    },
    // 大题号变化则页面置顶
    bingIndexNo: {
      handler() {
        this.scrollToTop()
      },
    },
    // 监听作答记录
    answerNotesArray: {
      handler(newval) {
        if (newval.length) {
          this.questionAnswerList = newval
          this.questionIfSave = true
          let index = this.$route.query.currentQuesIndex
          if (index) {
            // 找出实际的quesindex
            this.currentQuesIndex =
              this.questionAllList.findIndex((item) => {
                return item.index == index
              }) + 1
          }
        }
      },
      deep: true,
    },
    // 监听序号变化就传题过去
    currentQuesIndex: {
      handler(val) {
        console.log('currentQuesIndex', val)
        // index 变化弹层取消
        this.dialogVisible = false
        analytics.logEvent('hskweb_mockflow_dialogVisible', { show: false })
        // 切题就暂停音频
        if (!this.isExamMode) {
          this.$emit('stop')
        }
        if (this.status && val && val <= this.questionAllList.length && !this.isFinished) {
          this.selectQues('', '', true)
        }
      },
    },
  },
  created() {
    if (this.selectList.length) {
      let i = 0
      let k = 0
      this.answerSheetList = this.selectList.map((item) => {
        item.dataInfo = this.apartPartData(item.dataInfo)
        item.dataInfo.forEach((data) => {
          data.questionList.forEach((ques) => {
            if (!ques.index && !ques.is_example) {
              k++
              // 兼容yct没带index场景
              Object.assign(ques, { count: i }, { index: k })
              // // 套题小题中的题干无index,手动拼接
              // if (ques.questions) {
              //   ques.questions.forEach((q, z) => {
              //     q.index = data.questionList[0].index + z
              //   });
              // }
            } else {
              Object.assign(ques, { count: i })
            }
            i++
          })
        })
        return item
      })
      console.log('answerSheetList', this.answerSheetList)

      this.submitAnsDesc = this.answerSheetList.map((item, index) => {
        if (item.name == 'listen') {
          return {
            name: 'listen',
            status: [
              this.$t('hsk_end_preview'),
              this.$t('hsk_submit_listen'),
              this.$t('hsk_end_review'),
              this.$t('hsk_end_review'),
            ], // 多加一个结束回顾是因为,在听力进入下一环节时,保存数据超时,但是index + 1(保存也是在+1后保存)
          }
        } else if (index + 1 == this.answerSheetList.length) {
          return {
            name: item.name,
            status: ['', this.$t('hsk_submit_paper')],
          }
        } else {
          return {
            name: item.name,
            status: ['', `${this.$t('button_common_hand_in')} ${this.languageDesc[item.name]}`],
          }
        }
      })
      let j = 1
      this.selectList.forEach((list) => {
        list.dataInfo.forEach((data) => {
          data.questionList.forEach((ques) => {
            if (ques.is_example) {
              this.questionAllList.push(ques)
            } else {
              this.questionAllList.push({ ...ques, index: j })
              j++
            }
          })
        })
      })
      console.log('questionAllList', this.questionAllList)
    }
    let _this = this
    bus.$on('changeAbbreviationState', (val) => {
      _this.abbreviationState = val ? 1 : 0
    })
  },
  methods: {
    ifquestionManuaMark(questionItem) {
      // 类型是手动阅卷类型
      let manualMark = Object.values(MARK_RESULT_TYPE).includes(questionItem.topic_type)
        ? true
        : false
      if (questionItem.topic_type == 'lr' && questionItem.answers.length > 0) {
        //选择/填空混合题型选中选择题
        manualMark = false
      }
      return manualMark
    },
    scrollToTop() {
      // window.scrollTo(100, 500)
      this.$nextTick(() => {
        document.querySelector('.page').scrollTop = 0
      })
    },
    // 获取某个模块的题目数量
    getPartQuesNum(code) {
      return this.questionAllList.filter((item) => {
        return item.segment_code == code
      }).length
    },
    // 获取当前segmentCode模块之前的所有题目数量
    getNumsBeforeCurrentSegmentCode(segmentCode) {
      return (
        this.questionAllList.findIndex((item) => {
          return item.segment_code === segmentCode
        }) + 1
      )
    },

    getPartItemByQuesIndex(countDownDone = false) {
      let resSegment
      let currentPart
      let currentPartIndex
      // 不带例题的题号
      let currentQuestionIndex

      if (this.currentQuesIndex - this.globalExampleNum <= 0) {
        currentQuestionIndex = this.currentQuesIndex
      } else {
        currentQuestionIndex = this.currentQuesIndex - this.globalExampleNum
      }

      if (currentQuestionIndex > this.questionNum) {
        currentQuestionIndex = this.questionNum
      }

      console.log('有几个例题','跳转跳转part', this.partProgressList, this.currentQuesIndex,resSegment)
      this.partProgressList.forEach((segment) => {
        segment.parts.forEach((part, index) => {
          if (
            // part.startQuestion <= this.currentQuesIndex &&
            // part.endQuestion >= this.currentQuesIndex
            part.startQuestion <= currentQuestionIndex &&
            part.endQuestion >= currentQuestionIndex
          ) {
            resSegment = segment
            currentPartIndex = index
            currentPart = part
            // 当前题目在这部分
            part.currentPart = true
          }
        })
      })
      if (countDownDone) {
        console.log(222222222222222222222222222)
        resSegment.parts.forEach((part, index) => {
          if (part.partCode == this.partCode) {
            currentPartIndex = index
            currentPart = part
            part.currentPart = true
          }
        })
      }
      console.log(resSegment, currentPart, currentPartIndex)
      return {
        segment: resSegment,
        currentPart,
        currentPartIndex,
      }
    },

    /**
     * @type String (segmentStart|partEnd)
     *
     */
    partStartOrEnd(type) {
      // 1. 大模块开始,将大模块下的第一个启用
      if (type == 'segmentStart') {
        console.log('partStartOrEnd  segmentStart~!!!!!!!!!!!!!!!!!')
        // 大模块开始的启用；
        let { segment, currentPart } = this.getPartItemByQuesIndex()
        console.log(currentPart.part_answer_time > -1, 'currentPart.part_answer_time > -1')
        this.$emit('changePartTime', {
          time: currentPart.part_answer_time,
          partCode: currentPart.partCode,
        })

        if (segment.segmentCode == 'translation' && currentPart.partCode == 1) {
          // 开始翻译环节就进行选择；
          this.showTrasnlateLanguageDialog()
        }
        console.log(currentPart,'currentPartcurrentPartcurrentPart1')
        if (currentPart.part_answer_time == -1) {
          this.$emit('startExamAudio', currentPart)
        }
        return
      }

      let { segment, currentPart, currentPartIndex } = this.getPartItemByQuesIndex(
        type == 'countDownFinish'
      )
      if (type == 'countDownFinish') {
        this.currentQuesIndex = currentPart.endQuestion
      }
      let ifTheLastPart = segment.parts.length - 1 == currentPartIndex

      // 在大模块内部的流程，小模块结束；此时part不按照题号，按照正在倒计时part为准；
      // 2.自己的结束 -type == partEnd
      // 不是最后一个part,启用下一流程(a.小模块计时 b.音频播放)
      if (!ifTheLastPart) {
        console.log(currentPart,'currentPartcurrentPartcurrentPart12')
        let nextPart = segment.parts[currentPartIndex + 1]
        this.$emit('changePartTime', {
          time: nextPart.part_answer_time,
          partCode: nextPart.partCode,
        })
        if (nextPart.part_answer_time > -1) {
          // 下一个模块有part倒计时
          // 切换到下一题,开启下一个part的倒计时
          this.currentQuesIndex = this.currentQuesIndex + 1
          this.selectQues('', '', true)
        } else {
          // 下一个模块是音频流程题
          if (segment.segmentCode == 'translation' && nextPart.partCode == 2) {
            this.testRadioDialogShow = true
          } else {
            this.$emit('startExamAudio', nextPart)
          }
        }
      } else {
        console.log('partStartOrEnd调用finish')
        //是最后一个part,并且duration 等于 -1 需要调用finish结束
        if (segment.duration == -1) {
          this.finish('partTimeEnd')
        }
      }

      // 如果结束的是当前的最后一个模块,调用finish
      console.log(this.partProgressList, '~~~~~~~~~~~')
    },
    // 1 倒计时结束后监听执行 2 切换不同模式也会调用 3.预览音结束之后在父组件也会调用
    finish: debounce(async function (trigger) {
      console.log('Trigger: ', trigger)
      console.log('this.currentQuesIndex: ', this.currentQuesIndex, this.questionAllList)
      this.$refs.countDown && this.$refs.countDown.pause()
      // 如果正在录音，要暂停录音；如果是手动提交试卷，需要上传录音；
      if (this.currentQuesIndex > this.questionAllList.length) {
        this.currentQuesIndex = this.questionAllList.length - 1
      }
      let segment_code =
        this.questionAllList[
          (this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)) - 1
        ].segment_code
      let mixpanelParams = {
        people_id: this.peopleId,
        unlimited: this.unlimited,
        exam_type: this.currentLevelActive.level_name,
        section: segment_code == 'write' ? 'writing' : segment_code + 'ing',
        paper_type: this.title,
        final: false,
      }
      analytics.logEvent('hskweb_mock_finish', Object.assign(mixpanelParams, { trigger: trigger }))
      console.log('segment_code:::', segment_code)
      if (segment_code == 'listen') {
        this.ansProgressStatus++
        if (this.ansProgressStatus > 3) {
          this.ansProgressStatus = 3 // 异常数据重新提交
        }
        console.log(this.ansProgressStatus,'this.ansProgressStatusthis.ansProgressStatus')
        if (this.ansProgressStatus == 1) {
          this.currentQuesIndex = 1 // 如果预览过程中切换成别的题,强行设置成第一题
          this.currentVoiceIndex = this.currentQuesIndex
          this.selectQues('', '', true)
          this.isShowReviewTip = true
        } else if (this.ansProgressStatus == 2) {
          // 存在提前提交听力的场景,此时暂停音频
          this.$player.stop()
          analytics.logEvent('hskweb_mocksubmit_click', mixpanelParams)
        } else if (this.ansProgressStatus == 3) {
          await this.saveApiRequest(false)
          this.ansProgressStatus = 1
          this.accumulationNum = this.currentQuesIndex = this.getPartQuesNum('listen') + 1
        }
      } else {
        if (segment_code == 'translation' || segment_code == 'speaking') {
          this.$player.stop()
          // this.
        }
        this.ansProgressStatus = 1
        // 不是最后一个模块才走保存,如果是最后直接提交
        const isNotLastSegment =
          segment_code !== this.questionAllList[this.questionAllList.length - 1].segment_code
        if (isNotLastSegment) {
          await this.saveApiRequest(false)
          analytics.logEvent('hskweb_mocksubmit_click', mixpanelParams)
        }
        console.log('this.accumulationNum', this.accumulationNum)
        console.log('segment_code', segment_code)
        console.log('this.getPartQuesNum(segment_code)', this.getPartQuesNum(segment_code))
        this.currentQuesIndex = this.accumulationNum + this.getPartQuesNum(segment_code)
        this.accumulationNum = this.currentQuesIndex
      }
      this.$emit('progressStatus', this.ansProgressStatus)
      // TODO: bug .......
      analytics.logEvent('hskweb_mockflow_finish', {
        accumulationNum: this.accumulationNum,
        questionAllList: this.questionAllList.length,
        trigger, // 触发finish方式
      })
      console.log('this.accumulationNum', this.accumulationNum)
      console.log('this.questionAllList.length', this.questionAllList, this.questionAllList.length)
      if (this.accumulationNum <= this.questionAllList.length) {
        // 有下一个环节

        //开启新segmengt下的part
        this.partStartOrEnd('segmentStart')
        setTimeout(() => {
          console.log('this.ansProgressStatus', this.ansProgressStatus)
          this.$emit('changeTime', this.ansProgressStatus)
        })
      } else {
        console.log('提交试卷')
        // 提交试卷
        // 倒计时结束触发提交时通知到vuex倒计时结束给abbreviationSimulation组件保存答案内容使用
        if (trigger === 'timeEnd') {
          await this.$store.dispatch('notificationTimeout', true)
        }
        this.isFinished = true
        setTimeout(() => {
          this.saveApiRequest(true)
        }, 0)
      }
    }, 1000),
    // 提交试卷且暂停倒计时
    submit() {
      this.dialogVisible = true
      analytics.logEvent('hskweb_mockflow_dialogVisible', { show: true })
    },
    // 获取当前环节未作答题目数量
    getNoAnswerCount(segmentCode) {
      let unSelectedCount = 0
      let isFinishSubmit = false
      if (segmentCode == this.questionAllList[this.questionAllList.length - 1].segment_code) {
        isFinishSubmit = true
      }
      // let segmentCode = this.questionAllList[this.currentQuesIndex - 1].segment_code
      for (let i = 0; i < this.questionAnswerList.length; i++) {
        const dt = this.questionAnswerList[i]
        if (dt.segmentCode == segmentCode) {
          console.log('dt.segmentCode ', dt.segmentCode)
          unSelectedCount += dt.answer ? 0 : 1
        }
      }
      // 1、结束预览：'是否结束预览？预览结束后，将开始听力环节的考试'
      // 2、提交听力：'你有xx道听力题未作答，是否提交听力？提交后，听力环节结束。'
      // 3、结束回顾：'是否结束听力回顾，听力回顾结束后，将开始阅读环节的考试。'
      // 4、提交阅读：你有xx道阅读题未作答，是否提交阅读？提交后，阅读环节结束，无法返回进行修改。
      // 5. 提交写作： 你有xx道写作题未作答，是否提交写作？提交后，写作环节结束，无法返回进行修改。
      // 6. 提交翻译：  你有xx道翻译题未作答，是否提交翻译？提交后，翻译环节结束，无法返回进行修改。
      // 5、提交试卷：你有x道翻译题未作答，是否提交试卷？
      let desc = ''
      if (segmentCode == 'listen') {
        switch (this.ansProgressStatus) {
          case 0:
            desc = this.$t('hsk_enter_next_segment_preview')
            break
          case 1:
            desc =
              (unSelectedCount > 0
                ? this.$tc('hsk_enter_next_segment_listen_tip', unSelectedCount, {
                    count: unSelectedCount,
                  })
                : '') + this.$t('hsk_enter_next_segment_listen')
            break
          case 2:
            desc = this.$t('hsk_enter_next_segment_listen_review')
            break
          default:
            break
        }
      } else if (segmentCode == 'read') {
        desc =
          (unSelectedCount > 0
            ? this.$tc('hsk_enter_next_segment_read_tip', unSelectedCount, {
                count: unSelectedCount,
              })
            : '') +
          (isFinishSubmit
            ? this.$t('hsk_enter_next_segment_write')
            : this.$t('hsk_enter_next_segment_read'))
      } else if (segmentCode == 'write') {
        desc =
          (unSelectedCount > 0
            ? this.$tc('hsk_enter_next_segment_write_tip', unSelectedCount, {
                count: unSelectedCount,
              })
            : '') +
          (isFinishSubmit
            ? this.$t('hsk_enter_next_segment_write')
            : this.$t('hsk_enter_next_segment_write_high'))
      } else if (segmentCode == 'translation') {
        desc =
          (unSelectedCount > 0
            ? this.$tc('hsk_enter_next_segment_translate_tip', unSelectedCount, {
                count: unSelectedCount,
              })
            : '') +
          (isFinishSubmit
            ? this.$t('hsk_enter_next_segment_write')
            : this.$t('hsk_enter_next_segment_translate'))
      } else {
        desc =
          (unSelectedCount > 0
            ? this.$tc('hsk_enter_next_segment_speaking_tip', unSelectedCount, {
                count: unSelectedCount,
              })
            : '') + this.$t('hsk_enter_next_segment_write')
      }

      console.log(segmentCode, '剩余未答题' + unSelectedCount)
      return desc
    },
    getQuesListIndexForVoice(val) {
      console.log(val)
      console.log(this.listenNumList, 'this.listenNumList>>>>>>>>>>>>>>>>>>')
      let i = 0
      let sum = 0
      for (let j = 0; j < this.listenNumList.length; j++) {
        i += this.listenNumList[j]
        if (i >= val) {
          sum = j + 1
          break
        }
      }
      console.log(sum, 'summmmmmmmmmmmmm')
      return sum
    },
    // 上一题
    onPrev(text) {
      if (this.disabledPrevButton) return
      if (this.isRecording) {
        //正在录音，禁止手动点击
        return
      }
      analytics.logEvent('hskweb_mockClick_prev', { text })
      // 如果是套题直接进入上一个大题
      console.log(this.questionAllList, 'this.questionAllList')
      console.log(this.currentQuesIndex - 1, 'this.currentQuesIndex - 1')
      console.log(this.questionAllList[this.currentQuesIndex - 1].ifGroup)
      if (this.questionAllList[this.currentQuesIndex - 1].ifGroup) {
        this.currentQuesIndex -= this.questionAllList[this.currentQuesIndex - 1].nnum
      } else {
        this.currentQuesIndex--
      }
    },
    // 下一题
    onNext(text) {
      if (this.disabledNextButton) return
      if (this.isRecording) {
        //正在录音，禁止手动点击
        return
      }
      analytics.logEvent('hskweb_mockClick_next', { text })
      // 如果是套题直接进入下一个大题
      if (this.questionAllList[this.currentQuesIndex - 1].ifGroup) {
        this.currentQuesIndex += this.questionAllList[this.currentQuesIndex - 1].num
      } else {
        this.currentQuesIndex++
      }
    },

    // 播放点击事件
    playClickHandler() {
      if (this.isExamMode) return
      this.$emit('play')
    },
    //暂停播放事件
    stopClickHandler() {
      if (this.isExamMode) return
      this.$emit('pause')
    },
    /**
     * 选择题 页面初始化之后在父组件中就调用了
     * @parms status true 为点击下一题进入,false为选择题号进入
     */
    selectQues(quesObj, currentModule, status) {
      if (status == false && this.isRecording) {
        //正在录音，禁止手动点击
        return
      }
      console.log('selectQues 题号切换了')
      // 主动点击时，上报点击的序号
      if (!status && quesObj?.segment_code) {
        analytics.logEvent('hskweb_mockClick_serialNumber', {
          part: quesObj.segment_code,
          number: quesObj.index,
        })
      }
      this.status = status
      this.groupAnsList = []
      let currQuesObj
      console.log('this.questionAllList', this.questionAllList)
      if (quesObj) {
        currQuesObj = quesObj
        this.currentQuesIndex =
          this.questionAllList.findIndex((item) => {
            return item.index == currQuesObj.index
          }) + 1
      } else {
        currQuesObj = this.getAuesObj
      }
      this.bingIndexNo = currQuesObj.bigIndex
      currentModule
        ? (this.currentModule = this.$t(`hsk_${currentModule.segment_code}_part_title`, {
            count: currentModule.part_code,
          }))
        : ''
      // 把自己的答案拼进去,已便于做题回显
      let j = 0
      console.log('currQuesObj', currQuesObj)
      if (currQuesObj.questions) {
        // 判断当前套题前面有几个例题
        let exampleNum = this.questionAllList.filter((item) => {
          return item.bigIndex < currQuesObj.bigIndex && item.is_example
        }).length
        this.globalExampleNum = exampleNum
        console.log(exampleNum,'有几个例题')
        for (let i = 0; i < currQuesObj.questions.length; i++) {
          if (currQuesObj.questions[i].is_example) continue
          console.log('j', j)
          console.log(
            this.questionAnswerList[currQuesObj.bigIndex - 1 + j - exampleNum],
            'this.questionAnswerList[currQuesObj.bigIndex - 1 + j - exampleNum]'
          )
          this.groupAnsList[j] =
            this.questionAnswerList[currQuesObj.bigIndex - 1 + j - exampleNum].answer
          j++
        }
        console.log('套题存的数组', this.groupAnsList,exampleNum,1111111)
        let playIndex = this.getQuesListIndexForVoice(this.currentVoiceIndex)
        Object.assign(currQuesObj, {
          answer: this.groupAnsList,
          currentPlayIndex: this.questionAllList[playIndex ? playIndex - 1 : 0].index,
          currentPlayBigIndex: this.questionAllList[playIndex ? playIndex - 1 : 0].bigIndex,
        })
      } else {
        // 找到currentQuesIndex所在questionAnswerList的哪一个
        let ansIndex = this.questionAllList[this.currentQuesIndex - 1].index
        ansIndex &&
          Object.assign(currQuesObj, {
            answer: this.questionAnswerList[ansIndex - 1].answer,
          })
      }
      this.getBigType()
      this.$emit('currentSelect', currQuesObj)
      console.log('回传的数据（用于记录作答记录）', currQuesObj)

      this.$nextTick(() => {
        this.status = true
      })
    },
    getSaveSegmentCountDown(isHalfway) {
      if (!isHalfway) {
        return -1
      }
      console.log('一半退出')
      let { segment } = this.getPartItemByQuesIndex()
      console.log(segment, 'getsaveSegmentCountDown111')
      let countDownFlag = false
      if (
        (segment.segmentCode == 'translation' && this.partCode == 1) ||
        segment.segmentCode == 'write'
      ) {
        countDownFlag = true
      }
      let { currentPart, currentPartIndex } = this.getPartItemByQuesIndex(countDownFlag)
      // segment 下duration有值,存入countDown
      console.log(
        this.$refs.partCountDown.remain,
        'this.$refs.partCountDown.remainthis.$refs.partCountDown.remainthis.$refs.partCountDown.remainthis.$refs.partCountDown.remain'
      )
      console.log(
        currentPart.part_answer_time,
        'currentPart.part_answer_timecurrentPart.part_answer_timecurrentPart.part_answer_time'
      )
      if (segment.duration > -1) {
        return this.$refs.countDown.remain
      }
      // part倒计时有值 存入 part.remain + 后续part.part_answer_time 的和(用于拿countDown,计算到第几题了)
      if (segment.segmentCode == 'translation') {
        if (currentPart.part_answer_time == -1) {
          return -2
        } else if (currentPart.part_answer_time > 0 && this.$refs.partCountDown.remain == -1) {
          return 2000
        }
        // 目前在翻译第二环节
      }
      if (currentPart.part_answer_time > -1) {
        let remain = this.$refs.partCountDown.remain
        segment.parts.forEach((part, index) => {
          if (index > currentPartIndex && part.part_answer_time > -1) {
            remain += part.part_answer_time
          }
        })
        return remain
      }
      return -1
    },
    // 保存答案调用接口
    // 第二个参数给中途退出用
    saveApiRequest(status, isHalfway) {
      console.log('saveApiRequest', this.questionAnswerList)
      console.log(isHalfway, 'isHalfway')
      // 获取当前环节的下一个环节描述
      let nextPartDesc = this.selectList[Number(this.deepActiveName)]
        ? this.selectList[Number(this.deepActiveName)].name
        : ''
      let obj = {
        paperIdStr: this.paperId.toString(),
        paperId: 1,
        questionAnswerList: this.questionAnswerList,
        countDown: this.getSaveSegmentCountDown(isHalfway),
        examinationType: 2,
        segmentCode: isHalfway
          ? this.questionAllList[
              (this.currentQuesIndex || this.getQuesListIndexForVoice(this.currentVoiceIndex)) - 1
            ]?.segment_code
          : nextPartDesc,
        audioIndex: this.currentVoiceIndex,
        abbreviationState: this.abbreviationState || 0,
        examination_id:
          this.examinationId ||
          this.$route.query.examination_id ||
          getQueryString('examination_id'),
      }
      console.log('保存题目接口', obj)
      // debugger
      // let examination_id = this.examinationId || this.$route.query.examinationId;
      // examination_id && (obj.examination_id = examination_id);
      return new Promise((resolve) => {
        // apiRequest.post(ApiPath.hsk_save_result, obj, { loading: true }).then((res) => {
        //   console.log(res);
        //   // this.canSubmit = true
        //   status && this.submitResult();
        //   resolve(true);
        // });
        window.utilV2.postData(
          window.ApiPath.hsk_save_result,
          JSON.stringify(obj),
          () => {
            console.log('题目保存成功')
            status && this.submitResult()
            resolve(true)
          },
          () => {},
          {
            contentType: 'application/json',
          }
        )
      })
    },
    // 提交试卷
    submitResult() {
      const params = {
        paperId: this.$route.query.paperId,
        examinationType: this.$route.query.examinationType,
        examination_id:
          this.examinationId ||
          this.$route.query.examination_id ||
          getQueryString('examination_id'),
      }
      if (this.$route.query.assignment_id) {
        Object.assign(params, {
          assignment_id: this.$route.query.assignment_id,
        })
      }
      console.log('hsk_submit_result')
      utilV2.postData(
        +this.$route.query.examinationType === 4
          ? ApiPath.home_save_result
          : ApiPath.hsk_submit_result,
        params,
        (data) => {
          console.log('提交成功', data)
          this.$emit('submitAnswer')
          let params = Object.assign({}, this.$route.query, {
            nameTrans:
              typeof this.$route.query.nameTrans == 'string'
                ? this.$route.query.nameTrans
                : JSON.stringify(this.$route.query.nameTrans),
          })
          this.$router.replace({
            name: 'ResultReport',
            query: {
              ...params,
              name: this.title,
              examination_id:
                this.examinationId ||
                this.$route.query.examination_id ||
                getQueryString('examination_id'),
            },
          })
        }
      )
    },
    // 判断当前index属于哪个大类
    getBigType() {
      let num = 1
      this.selectList.forEach((item, index) => {
        item.dataInfo.forEach((data) => {
          data.questionList.forEach((eg) => {
            if (eg.count === this.currentQuesIndex - 1) {
              num = index + 1
              return
            }
          })
        })
      })
      this.activeName = num.toString()
      this.deepActiveName = num.toString()
    },
    cancel() {
      this.dialogVisible = false
      analytics.logEvent('hskweb_mockflow_dialogVisible_cancel')
    },
    cancelPreview() {
      this.previewVisible = false
      if (this.isShowReviewTip) this.isShowReviewTip = false
    },
    async confirm() {
      this.finish('click')
      this.dialogVisible = false
      analytics.logEvent('hskweb_mockflow_dialogVisible_confirm')
      console.log('显示听力回顾提示?', this.ansProgressStatus, this.isShowReviewTip)
      if (this.ansProgressStatus == 1 && this.isShowReviewTip) {
        console.log('显示听力回顾提示')
        this.previewVisible = true
      }
    },
    //环节code一致的分组合并
    // apartPartData(list) {
    //   let typeList = [] //定义空数组，用于装载去重之后的数组，
    //   let returnList = [] //返回的数组
    //   if (list) {
    //     //如果有值
    //     list.forEach((item, index) => {
    //       //可以用indexOf()数组去重 如果检索的结果匹配到,则返回 1. 如果检索的结果没有匹配值,则返回 -1.
    //       if (typeList.indexOf(item.part_code) === -1) {
    //         typeList.push(item.part_code)
    //         this.$set(returnList, index, item)
    //       } else {
    //         console.log(returnList[index - 1])
    //         this.$set(returnList, index - 1, {
    //           ...returnList[index - 1],
    //           questionList: returnList[index - 1].questionList.concat(item.questionList),
    //         })
    //       }
    //     })
    //   }
    //   return returnList
    // },
    apartPartData(list) {
      let typeList = []
      let returnList = []
      list.forEach((item) => {
        let idx = typeList.indexOf(item.part_code)
        if (idx === -1) {
          typeList.push(item.part_code)
          returnList.push(item)
        } else {
          returnList[idx].questionList = returnList[idx].questionList.concat(item.questionList)
        }
      })
      return returnList
    },
    // 显示翻译语言选择
    showTrasnlateLanguageDialog() {
      console.log('showTrasnlateLanguageDialog 调用了')
      console.log(this.getAuesObj, 'getAuesObj~~~~~~~~~~~~~~~')
      this.languageList = getLanguageSelectList(this.getAuesObj.screen_text_trans)
      console.log(this.languageList)
      this.translationLanguage =
        sessionStorage.getItem('translationLanguage') || this.languageList[0].value
      this.showTranslateLanguageDialog = true
    },
    closeTranslationLanguageDialog() {
      this.showTranslateLanguageDialog = false
    },
    changeLanguage() {
      this.$store.commit('SET_EXAMNATION_TRANSLATION_LANGUAGE', this.translationLanguage)
    },
    // 翻译关闭，进入第二模块
    closeTestAudio() {
      this.testRadioDialogShow = false
      this.$emit('play')
      console.log('翻译关闭，进入第二模块')
      let { segment, currentPart, currentPartIndex } = this.getPartItemByQuesIndex()
      let nextPart = segment.parts[currentPartIndex + 1]
      this.$emit('startExamAudio', nextPart)

      // 播放当前的audioIndex;
    },
  },
}
</script>

<style lang="scss" scoped>
.part-code-tips {
  text-align: center;
  margin-top: 20px;
  font-size: 18px;
  font-family: Inter;
}
.content-body {
  flex-direction: row;
  justify-content: center;
  .stem {
    width: 750px;
    min-height: 498px;
    height: auto;
    flex: initial;
    &--title {
      min-height: 74px;
      border-bottom: 1px solid #ebeff2;
      position: relative;
      &_text {
        padding: 15px 28px;
        .proportion {
          display: flex;
          justify-content: space-between;
          height: 27px;
          span {
            display: inline-block;
            font-size: 12px;
            // font-family: PingFangSC-Regular, Inter;
            font-weight: 400;
            color: rgba(134, 141, 153, 1);
            line-height: 12px;
            margin-top: 10px;
            margin-right: 10px;
          }
          .left {
            display: flex;
            align-items: center;
            .playing {
              width: 20px;
              height: 20px;
              margin-top: 7px;
            }
          }
        }
      }
    }
  }
  .tools {
    width: 220px;
    min-height: 498px;
    flex: initial;
    margin-right: 30px;
    .count_down {
      margin-top: 34px;
      &_null {
        margin-top: 34px;
        text-align: center;
        font-weight: 500;
        color: #faae56;
        line-height: 20px;
        font-size: 20px;
      }
    }
    .time-remaining {
      font-size: 12px;
      font-weight: 400;
      color: rgba(134, 141, 153, 1);
      line-height: 12px;
      margin-top: 10px;
      text-align: center;
    }
    .btn-submit {
      width: 100%;
      height: 28px;
      border-radius: 6px;
    }
    ::v-deep .toolbar {
      height: 78px;
    }
    .subject_list {
      padding: 0px 18px;
      .collapse-list {
        margin-top: 30px;
        border: 0;
        ::v-deep.el-collapse-item {
          margin-bottom: 20px;
          &__header {
            border-radius: 6px;
            border: 1px solid rgba(208, 213, 221, 1);
            width: 182px;
            height: 28px;
          }
          &__wrap {
            border: 0;
          }
          &__content {
            padding-bottom: 0;
          }
        }
        .type {
          margin-left: 7px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(57, 61, 70, 1);
          line-height: 12px;
        }
        img {
          margin-left: 17px;
          width: 14px;
          height: 14px;
        }
      }
      &-flex {
        width: 100%;
        display: flex;
        position: relative;
        justify-content: center;
      }
      &-line {
        width: 100%;
        height: 1px;
        background-color: #f6f8fc;
        position: absolute;
        left: 0px;
        top: 16px;
      }
      &-item {
        margin: 13px 0 0 4px;
        span {
          display: inline-block;
          width: 24px;
          height: 24px;
          border: 1px solid #ebeff2;
          border-radius: 12px;
          margin-right: 10px;
          margin-bottom: 10px;
          text-align: center;
          font-size: 10px;
          color: rgba(57, 61, 70, 1);
          line-height: 22px;
          cursor: pointer;
        }
        .title {
          margin-bottom: 15px;
          margin-top: 10px;
          font-size: 10px;
          font-weight: 400;
          color: rgba(121, 124, 127, 1);
          line-height: 12px;
          display: inline-block;
          background-color: #fff;
          z-index: 2;
          padding: 0px 10px;
        }
        .active {
          background-color: #faae56;
          color: #fff;
        }
        .finished {
          border-color: #faae56;
        }
        .notAllowed {
          cursor: not-allowed;
        }
        .right {
          border-color: #09cba0;
          color: #09cba0;
          background-color: #fff;
        }
        .error {
          border-color: #fc5a5a;
          color: #fc5a5a;
          background-color: #fff;
        }
        .unmarked {
          border-color: #b5b5be;
          color: #b5b5be;
          background-color: #fff;
        }
      }
    }
  }
}
.page-tools {
  display: flex;
  width: 750px;
  justify-content: space-between;
  align-items: center;
  margin-top: 21px;
  &-disable-prev {
    justify-content: flex-end;
  }
  &-disable-next {
    justify-content: flex-start;
  }
  ::v-deep.elst-button__prev,
  ::v-deep.elst-button__next {
    img {
      width: 63px;
      height: 63px;
    }
  }
  .prev,
  .next {
    position: relative;
    min-width: 82px;
    cursor: pointer;
    .number {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 148px;
      height: 52px;
      border-radius: 95px;
      background: rgba(250, 174, 86, 0.1);
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 20px;
      color: #faae56;
    }
    .arrow-left,
    .arrow-right {
      position: absolute;
      width: 50px;
      height: 50px;
      background: #fff;
      border-radius: 50%;
      right: 2px;
      top: 1px;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-icon-back,
      .el-icon-right {
        font-size: 25px;
        color: #faae56;
      }
    }
    .arrow-right {
      left: 2px;
      right: auto;
    }
  }

  .prev-disable,
  .next-disable {
    cursor: not-allowed;
    .number {
      visibility: hidden;
      color: #b5b5be;
      background: #fff;
    }
    .arrow-right {
      background: #efeff1;
      .el-icon-back {
        color: rgba(181, 181, 190, 1);
      }
    }
    .arrow-left {
      background: #efeff1;
      .el-icon-back {
        color: rgba(181, 181, 190, 1);
      }
    }
  }
}
::v-deep .el-dialog__footer {
  padding: 0;
  font-size: 16px;
}
::v-deep .el-dialog__header {
  padding: 0;
}
::v-deep .el-dialog__body {
  text-align: center;
  font-size: 17px;
  word-break: break-word;
}
.dialog-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid #f2f3f5;
  span {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 59px;
    cursor: pointer;
    &:first-child {
      border-right: 1px solid #f2f3f5;
    }
  }
  &-preview {
    text-align: center;
    .btn-submit {
      min-width: 126px;
      max-width: 250px;
      min-height: 30px;
      border-radius: 17px;
      color: #fff;
      background-color: #fff;
      margin-bottom: 20px;
      white-space: normal;
      line-height: 20px;
    }
  }
}
.angle-rounded {
  ::v-deep .el-dialog {
    border-radius: 10px;
    word-break: break-word;
  }
}
.submit-dialog {
  .submit-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    .button-cancel {
      min-width: 78px;
      border: 1px solid #dedede;
      border-radius: 17px;
    }
    .button-ok {
      min-width: 78px;
      background: #faae56;
      margin-left: 15px;
      border-radius: 16px !important;
    }
  }
  ::v-deep .el-dialog {
    border-radius: 10px;
    word-break: break-word;
  }
}
.part-count-down-con {
  position: absolute;
  right: 24px;
  top: 84px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  .part-count-down-text {
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin: 5px 0;
    text-align: center;
  }
}
.language-dialog {
  .submit-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    margin-top: -28px;
  }
  .translate-language-dialog {
    .translate-language-dialog-title {
      text-align: left;
      color: #2c2f46;
      font-size: 16px;
      font-weight: bold;
      margin-top: -10px;

      border-bottom: 1px solid #efeff1;
      padding-bottom: 20px;
    }
  }
  .language-select-con {
    padding: 24px 0 30px 0;
    text-align: left;
    border-bottom: 1px solid #efeff1;
    .title {
      color: #b5b5be;
      font-size: 12px;
      margin-bottom: -2px;
      position: relative;
      z-index: 100;
    }
    .language-select {
      width: 400px;
    }
  }
}

::v-deep .language-select-con .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #b5b5be !important;
  color: #2c2f46;
  padding: 0 15px 0 0;
  border-radius: 0;
}
::v-deep .language-select-con .el-select .el-input .el-select__caret {
  font-weight: bold;
}
::v-deep .test-radio {
  .el-dialog__header {
    border-bottom: 1px solid #e9e9e9;
    padding: 20px 20px 10px;
    .el-dialog__title {
      color: #2c2f46;
      font-size: 18px;
      font-weight: 700;
    }
  }
  .el-dialog {
    border-radius: 0px;
  }
  .el-dialog__body {
    padding: 30px 50px 24px;
    text-align: left;
  }
}
</style>
